import { Typography, Flex } from 'antd';

import CourseCard from '../../components/LMSComponent/CourseCard';
interface LMSModulesProps {
  courseData: any;
  onModuleClick: (module: any) => any;
}
export default function LMSModules({
  courseData,
  onModuleClick,
}: LMSModulesProps) {
  return (
    <>
      <Typography.Title
        className="page-sub-heading"
        level={4}
        style={{ marginTop: 0, marginBottom: '10px' }}
      >
        Modules
      </Typography.Title>
      <Flex wrap gap="24px">
        {courseData.modules.map((module: any) => (
          <CourseCard
            key={module.id}
            title={module.name}
            imageUrl={module.thumbnail?.url || ''}
            count={module.chapterCount}
            cardType="video"
            completionPercentage={module.percentage.toFixed(0) || 0}
            onPlayButtonClick={(module: any) => onModuleClick(module)}
            module={module}
          />
        ))}
      </Flex>
    </>
  );
}
